<template>
  <div class="certificate-detail-view">
    <section class="section dynamic-height" ref="form">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="sticky-top" :class="hasShadow">
            <title-component :size="1">
              <translate>Show certificate</translate>
              <action-dropdown-component
                v-if="actions.length"
                :actions="actions">
              </action-dropdown-component>
              <status-component
                v-if="certificate.id"
                class="is-pulled-right state"
                :level="certificate.state.level"
                :display="certificate.state.display">
              </status-component>
            </title-component>
          </div>
          <br>
          <div class="scrollable-content">
            <message-component
              v-if="certificate.hasComment"
              :level="certificate.comment.state.displayLevel">
              {{ certificate.comment.text }}
            </message-component>
            <title-component
              :size="2"
              :lineSeparator="'under'">
              <translate>Certificate</translate>
            </title-component>
            <grid-details-component
              v-if="certificate.id"
              :display_spec="certificateSpecs"
              :item="certificate"
              :item_keys="certificate_keys">
            </grid-details-component>
            <title-component
              :size="2"
              :lineSeparator="'under'">
              <translate>Customer</translate>
            </title-component>
            <grid-details-component
              v-if="certificate.id"
              :display_spec="customerProfileSpecs"
              :item="certificate.customer"
              :item_keys="customer_keys">
            </grid-details-component>
            <tabs-router-component class="reporting-tab" :tabs="routes">
            </tabs-router-component>
          </div>
        </div>
      </div>
    </section>
    <section class="section dynamic-height">
      <div class="columns is-multilined">
        <div class="column is-12">
          <tabs animation="fade" :only-fade="true" class="certificate-tab">
            <tab-pane label="Certificate">
              <iframe v-if="certificate.id" :src="Certificate.getCertificateStaticLink(certificate.id)" class="certificate"></iframe>
            </tab-pane>
            <tab-pane label="Decision letter">
              <iframe v-if="certificate.id" :src="Certificate.getDecisionLetterStaticLink(certificate.id)" class="decision-letter"></iframe>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </section>
    <!-- Popup for creating an id card order-->
    <card-modal-component
      :show="show_id_card_modal"
      @deactivate="toggleIdCardModal()"
      transition="fade"
      ref="id_card_modal"
      :options="{hasOkBtn: { text: 'Order card' }, hasCancelBtn: { enabled: true }}"
      @handleOk="createIdCardOrder($event)"
      @handleCancel="toggleIdCardModal()"
      :title="`Order id card`">
      <div slot="card-content" class="field">
        <div class="control">
          <p v-translate>Please confirm that you want to order a card and also accept that you will be invoiced for this order which is currently priced at 495 SEK excluding VAT.</p>
        </div>
      </div>
    </card-modal-component>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { certificateSpecs, customerProfileSpecs, certificateReportSpecs, defaultCustomerKeys } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import Tabs from '@/components/layout/tabs/tabs_content/Tabs'
  import TabPane from '@/components/layout/tabs/tabs_content/TabPane'
  import ActionDropdownComponent from '@/components/layout/utility/ActionDropdownComponent'
  import StatusComponent from '@/components/layout/utility/StatusComponent.vue'
  import { setPageHeightMixin, itemRefresher } from '@/mixins/mixins'
  import TabsRouterComponent from '@/components/layout/tabs/TabsRouterComponent.vue'
  import { Certificate } from '@/classes/certificate/Certificate'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'

  export default {
    name: 'certificate-detail-view',
    mixins: [setPageHeightMixin, itemRefresher],
    components: {
      CardModalComponent,
      GridDetailsComponent,
      TitleComponent,
      Tabs,
      TabPane,
      ActionDropdownComponent,
      StatusComponent,
      TabsRouterComponent,
      MessageComponent
    },
    data () {
      return {
        certificate_keys: ['certificateNumber', 'issueDate', 'expiryDate', 'validityPeriod', 'service.code', 'qualification.display'],
        customer_keys: defaultCustomerKeys,
        report_headings: ['For period', 'Reported at', 'Comment'],
        report_keys: ['periodDate', 'reportDate', 'self'],
        certificateReportSpecs: certificateReportSpecs,
        customerProfileSpecs: customerProfileSpecs,
        certificateSpecs: certificateSpecs,
        certificate_report_specs: [],
        actions: [],
        certificate: {},
        Certificate: Certificate,
        show_id_card_modal: false,
        setAction: this.setCertificate,
        routes: [
          {
            route: { name: 'ReportsUpcomingView' },
            text: 'Upcoming reportings'
          },
          {
            route: { name: 'ReportsCompletedView' },
            text: 'Completed reportings'
          }
        ]
      }
    },
    props: {
      certificateId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates,
        authUser: state => state.authModule.authUser
      })
    },
    methods: {
      ...mapActions([
        'successMessage',
        'orderIdCard',
        'setCertificate'
      ]),
      setActions () {
        this.actions = this.certificate.getCertificateActions(this.authUser, this.handleAction)
      },
      handleAction (actionType) {
        if (actionType === Certificate.ORDER_ID_CARD) {
          this.toggleIdCardModal()
        }
      },
      updateCertificateKeys () {
        if (this.certificate && this.certificate.isReportingHours) {
          if (this.certificate_keys.indexOf('reportData.totalNumberReportedHours') === -1) {
            this.certificate_keys.push('reportData.totalNumberReportedHours')
          }
        }
        if (this.certificate && this.certificate.isReportingSimpleProjects) {
          if (this.certificate_keys.indexOf('reportData.totalNumberReportedSimpleProjects') === -1) {
            this.certificate_keys.push('reportData.totalNumberReportedSimpleProjects')
          }
        }
        if (this.certificate && this.certificate.isReportingComplexProjects) {
          if (this.certificate_keys.indexOf('reportData.totalNumberReportedComplexProjects') === -1) {
            this.certificate_keys.push('reportData.totalNumberReportedComplexProjects')
          }
        }
      },
      toggleIdCardModal () {
        this.show_id_card_modal = !this.show_id_card_modal
      },
      createIdCardOrder () {
        this.orderIdCard(this.certificate.id).then(() => {
          this.show_id_card_modal = false
          this.$refs.id_card_modal.closeModal().then(() => {
            let callbacks = [this.updateCertificateKeys, this.setActions, this.switchCustomerKeys]
            this.setOrRefreshItem('certificate', this.certificates, this.certificateId, callbacks)
            this.successMessage(this.$ngettext('Card order created'))
          })
        }).catch((err) => {
          this.handleError(err)
        })
      },
      switchCustomerKeys () {
        if (this.certificate.customer.hasAdditionalCommunes) {
          if (!this.customer_keys.includes('communes')) {
            this.customer_keys.push('communes')
          }
        }
      }
    },
    created () {
      let callbacks = [this.updateCertificateKeys, this.setActions, this.switchCustomerKeys]
      this.setOrRefreshItem('certificate', this.certificates, this.certificateId, callbacks)
    }
  }
</script>

<style lang="sass" scoped>
  .main-view
    min-height: auto
  .state
    margin-top: 5px
    margin-right: 25px

  .certificate, .decision-letter
    width: 100%

  iframe
    min-height: 780px

  .reports-table thead th:nth-child(3)
    display: inline-block
    width: 50%
    background: orange
</style>
